import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatMoney } from '@/components/billing/formatMoney'
import { formatDateTimeDMY } from '@/utils/date'
import type { TeacherBalanceTransaction } from '@/types/tts'

interface BalanceTransactionsListProps {
  transactions: TeacherBalanceTransaction[]
}

export function BalanceTransactionsList({ transactions }: BalanceTransactionsListProps) {
  const { t } = useTranslation()

  if (transactions.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('balance.transactions.empty', 'Операций пока нет')}
      </Typography>
    )
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{t('balance.transactions.date', 'Дата')}</TableCell>
          <TableCell>{t('balance.transactions.type', 'Тип')}</TableCell>
          <TableCell align="right">{t('balance.transactions.amount', 'Сумма')}</TableCell>
          <TableCell align="right">{t('balance.transactions.balanceAfter', 'Баланс после')}</TableCell>
          <TableCell>{t('balance.transactions.description', 'Описание')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {transactions.map((transaction) => (
          <TableRow key={transaction.id}>
            <TableCell>
              {formatDateTimeDMY(transaction.created_at)}
            </TableCell>
            <TableCell>
              <Chip
                size="small"
                color={transaction.direction === 'credit' ? 'success' : 'default'}
                label={t(`balance.transactions.types.${transaction.type}`, transaction.type)}
              />
            </TableCell>
            <TableCell align="right">
              <Typography
                variant="body2"
                color={transaction.direction === 'credit' ? 'success.main' : 'text.primary'}
              >
                {transaction.direction === 'credit' ? '+' : '−'}
                {formatMoney(transaction.amount, transaction.currency)}
              </Typography>
            </TableCell>
            <TableCell align="right">
              {formatMoney(transaction.balance_after, transaction.currency)}
            </TableCell>
            <TableCell>{transaction.description ?? '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
